// wget --quiet \
//   --output-document="lga_name16.csv" \
//   --method GET \
//   --header 'Accept: */*' \
//   --header 'Cache-Control: no-cache' \
//   --header 'Host: staging-maps.geografia.com.au' \
//   - 'https://staging-maps.geografia.com.au/user/dlgrma/api/v2/sql?q=select%20lga_name18%0Afrom%20lga_2016_qld_boundaries&format=csv'
export default {
  "2006": [
    "Aurukun (S)",
    "Balonne (S)",
    "Banana (S)",
    "Barcaldine (R)",
    "Barcoo (S)",
    "Blackall-Tambo (R)",
    "Boulia (S)",
    "Brisbane (C)",
    "Bulloo (S)",
    "Bundaberg (R)",
    "Burdekin (S)",
    "Burke (S)",
    "Cairns (R)",
    "Carpentaria (S)",
    "Cassowary Coast (R)",
    "Central Highlands (R) (Qld)",
    "Charters Towers (R)",
    "Cherbourg (S)",
    "Cloncurry (S)",
    "Cook (S)",
    "Croydon (S)",
    "Diamantina (S)",
    "Doomadgee (S)",
    "Douglas (S)",
    "Etheridge (S)",
    "Flinders (S) (Qld)",
    "Fraser Coast (R)",
    "Gladstone (R)",
    "Gold Coast (C)",
    "Goondiwindi (R)",
    "Gympie (R)",
    "Hinchinbrook (S)",
    "Hope Vale (S)",
    "Ipswich (C)",
    "Isaac (R)",
    "Kowanyama (S)",
    "Livingstone (S)",
    "Lockhart River (S)",
    "Lockyer Valley (R)",
    "Logan (C)",
    "Longreach (R)",
    "Mackay (R)",
    "Mapoon (S)",
    "Maranoa (R)",
    "Mareeba (S)",
    "McKinlay (S)",
    "Migratory - Offshore - Shipping (Qld)",
    "Moreton Bay (R)",
    "Mornington (S)",
    "Mount Isa (C)",
    "Murweh (S)",
    "Napranum (S)",
    // "No usual address (Qld)", TODO: investigate why no data for 2011 exists
    "Noosa (S)",
    "North Burnett (R)",
    "Northern Peninsula Area (R)",
    "Palm Island (S)",
    "Paroo (S)",
    "Pormpuraaw (S)",
    "Quilpie (S)",
    "Redland (C)",
    "Richmond (S)",
    "Rockhampton (R)",
    "Scenic Rim (R)",
    "Somerset (R)",
    "South Burnett (R)",
    "Southern Downs (R)",
    "Sunshine Coast (R)",
    "Tablelands (R)",
    "Toowoomba (R)",
    "Torres (S)",
    "Torres Strait Island (R)",
    "Townsville (C)",
    "Weipa (T)",
    "Western Downs (R)",
    "Whitsunday (R)",
    "Winton (S)",
    "Woorabinda (S)",
    "Wujal Wujal (S)",
    "Yarrabah (S)"
  ],
  "2011": [
    "Aurukun (S)",
    "Balonne (S)",
    "Banana (S)",
    "Barcaldine (R)",
    "Barcoo (S)",
    "Blackall Tambo (R)",
    "Boulia (S)",
    "Brisbane (C)",
    "Bulloo (S)",
    "Bundaberg (R)",
    "Burdekin (S)",
    "Burke (S)",
    "Cairns (R)",
    "Carpentaria (S)",
    "Cassowary Coast (R)",
    "Central Highlands (R)",
    "Charters Towers (R)",
    "Cherbourg (S)",
    "Cloncurry (S)",
    "Cook (S)",
    "Croydon (S)",
    "Diamantina (S)",
    "Doomadgee (S)",
    "Etheridge (S)",
    "Flinders (S)",
    "Fraser Coast (R)",
    "Gladstone (R)",
    "Gold Coast (C)",
    "Goondiwindi (R)",
    "Gympie (R)",
    "Hinchinbrook (S)",
    "Hope Vale (S)",
    "Ipswich (C)",
    "Isaac (R)",
    "Kowanyama (S)",
    "Lockhart River (S)",
    "Lockyer Valley (R)",
    "Logan (C)",
    "Longreach (R)",
    "Mackay (R)",
    "Mapoon (S)",
    "Maranoa (R)",
    "McKinlay (S)",
    "Moreton Bay (R)",
    "Mornington (S)",
    "Mount Isa (C)",
    "Murweh (S)",
    "Napranum (S)",
    // "No usual address (Qld)",
    "North Burnett (R)",
    "Northern Peninsula Area (R)",
    "Palm Island (S)",
    "Paroo (S)",
    "Pormpuraaw (S)",
    "Quilpie (S)",
    "Redland (C)",
    "Richmond (S)",
    "Rockhampton (R)",
    "Scenic Rim (R)",
    "Somerset (R)",
    "South Burnett (R)",
    "Southern Downs (R)",
    "Sunshine Coast (R)",
    "Tablelands (R)",
    "Toowoomba (R)",
    "Torres (S)",
    "Torres Strait Island (R)",
    "Townsville (C)",
    "Unincorporated Qld",
    "Weipa (T)",
    "Western Downs (R)",
    "Whitsunday (R)",
    "Winton (S)",
    "Woorabinda (S)",
    "Wujal Wujal (S)",
    "Yarrabah (S)"
  ],
  "2016": [
    "Aurukun (S)",
    "Balonne (S)",
    "Banana (S)",
    "Barcaldine (R)",
    "Barcoo (S)",
    "Blackall-Tambo (R)",
    "Boulia (S)",
    "Brisbane (C)",
    "Bulloo (S)",
    "Bundaberg (R)",
    "Burdekin (S)",
    "Burke (S)",
    "Cairns (R)",
    "Carpentaria (S)",
    "Cassowary Coast (R)",
    "Central Highlands (R) (Qld)",
    "Charters Towers (R)",
    "Cherbourg (S)",
    "Cloncurry (S)",
    "Cook (S)",
    "Croydon (S)",
    "Diamantina (S)",
    "Doomadgee (S)",
    "Douglas (S)",
    "Etheridge (S)",
    "Flinders (S) (Qld)",
    "Fraser Coast (R)",
    "Gladstone (R)",
    "Gold Coast (C)",
    "Goondiwindi (R)",
    "Gympie (R)",
    "Hinchinbrook (S)",
    "Hope Vale (S)",
    "Ipswich (C)",
    "Isaac (R)",
    "Kowanyama (S)",
    "Livingstone (S)",
    "Lockhart River (S)",
    "Lockyer Valley (R)",
    "Logan (C)",
    "Longreach (R)",
    "Mackay (R)",
    "Mapoon (S)",
    "Maranoa (R)",
    "Mareeba (S)",
    "McKinlay (S)",
    "Migratory - Offshore - Shipping (Qld)",
    "Moreton Bay (R)",
    "Mornington (S)",
    "Mount Isa (C)",
    "Murweh (S)",
    "Napranum (S)",
    "No usual address (Qld)",
    "Noosa (S)",
    "North Burnett (R)",
    "Northern Peninsula Area (R)",
    "Palm Island (S)",
    "Paroo (S)",
    "Pormpuraaw (S)",
    "Quilpie (S)",
    "Redland (C)",
    "Richmond (S)",
    "Rockhampton (R)",
    "Scenic Rim (R)",
    "Somerset (R)",
    "South Burnett (R)",
    "Southern Downs (R)",
    "Sunshine Coast (R)",
    "Tablelands (R)",
    "Toowoomba (R)",
    "Torres (S)",
    "Torres Strait Island (R)",
    "Townsville (C)",
    "Weipa (T)",
    "Western Downs (R)",
    "Whitsunday (R)",
    "Winton (S)",
    "Woorabinda (S)",
    "Wujal Wujal (S)",
    "Yarrabah (S)"
  ],
  "2021": [
    "Aurukun (S)",
    "Balonne (S)",
    "Banana (S)",
    "Barcaldine (R)",
    "Barcoo (S)",
    "Blackall-Tambo (R)",
    "Boulia (S)",
    "Brisbane (C)",
    "Bulloo (S)",
    "Bundaberg (R)",
    "Burdekin (S)",
    "Burke (S)",
    "Cairns (R)",
    "Carpentaria (S)",
    "Cassowary Coast (R)",
    "Central Highlands (R) (Qld)",
    "Charters Towers (R)",
    "Cherbourg (S)",
    "Cloncurry (S)",
    "Cook (S)",
    "Croydon (S)",
    "Diamantina (S)",
    "Doomadgee (S)",
    "Douglas (S)",
    "Etheridge (S)",
    "Flinders (S) (Qld)",
    "Fraser Coast (R)",
    "Gladstone (R)",
    "Gold Coast (C)",
    "Goondiwindi (R)",
    "Gympie (R)",
    "Hinchinbrook (S)",
    "Hope Vale (S)",
    "Ipswich (C)",
    "Isaac (R)",
    "Kowanyama (S)",
    "Livingstone (S)",
    "Lockhart River (S)",
    "Lockyer Valley (R)",
    "Logan (C)",
    "Longreach (R)",
    "Mackay (R)",
    "Mapoon (S)",
    "Maranoa (R)",
    "Mareeba (S)",
    "McKinlay (S)",
    "Migratory - Offshore - Shipping (Qld)",
    "Moreton Bay (R)",
    "Mornington (S)",
    "Mount Isa (C)",
    "Murweh (S)",
    "Napranum (S)",
    "No usual address (Qld)",
    "Noosa (S)",
    "North Burnett (R)",
    "Northern Peninsula Area (R)",
    "Palm Island (S)",
    "Paroo (S)",
    "Pormpuraaw (S)",
    "Quilpie (S)",
    "Redland (C)",
    "Richmond (S)",
    "Rockhampton (R)",
    "Scenic Rim (R)",
    "Somerset (R)",
    "South Burnett (R)",
    "Southern Downs (R)",
    "Sunshine Coast (R)",
    "Tablelands (R)",
    "Toowoomba (R)",
    "Torres (S)",
    "Torres Strait Island (R)",
    "Townsville (C)",
    "Weipa (T)",
    "Western Downs (R)",
    "Whitsunday (R)",
    "Winton (S)",
    "Woorabinda (S)",
    "Wujal Wujal (S)",
    "Yarrabah (S)"
  ]
};



// WEBPACK FOOTER //
// ../data/qld/lgas.js